import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTableCells, faTimes } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import useAuthz from '../../hooks/useAuthz';

const ActionsEditDevisRenderer = (props) => {
  const { onAddNewLine, onOpenTarificationModal, onDeleteLine, rowIndex, disable, isFacture } = props;
  const [authz, user, profil] = useAuthz();

  return (
      <>
          {!disable &&
            <>
                <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
                    <div style={{ display: 'flex' }}>
                        {!props.node.rowPinned && (profil.profil === 1 || profil.profil === 2 || (isFacture && profil.profil === 3)) &&
                            <div className='buttons-request-table' style={{ backgroundColor: 'transparent' }}>
                                <FontAwesomeIcon icon={faTimes} style={{ color: '#0094CA', height: '18px' }}
                                                 onClick={() => onDeleteLine(rowIndex)} />
                            </div>
                        }

                        {props.node.rowPinned === 'bottom' && props.node.rowIndex === 0 &&
                            (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) &&
                            <div className='buttons-request-table' style={{ backgroundColor: 'transparent' }}>
                                <FontAwesomeIcon icon={faTableCells} style={{ color: '#0094CA', height: '18px' }}
                                                 onClick={onOpenTarificationModal} />
                            </div>
                        }

                        {props.node.rowPinned === 'bottom' && props.node.rowIndex === 0 && (profil.profil === 1 || profil.profil === 2 || (isFacture && profil.profil === 3)) &&
                            <div className='buttons-request-table' style={{ backgroundColor: 'transparent' }}>
                                <FontAwesomeIcon icon={faPlus} style={{ color: '#0094CA', height: '18px' }}
                                                 onClick={() => onAddNewLine(props.node.data)} />
                            </div>
                        }

                    </div>
                </div>
            </>
        }
      </>
);
};

export default ActionsEditDevisRenderer;